export default "__VITE_ASSET__DCVCewEI__"